export var Sizes = {
  X_SMALL: 'x-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export var Intensities = {
  DEFAULT: 'default',
  LIGHT: 'light'
};